import CSS from '../assets/svg/CSS.png';
import Express from '../assets/svg/Express.png';
import Git from '../assets/svg/Git.png';
import GitHub from '../assets/svg/GitHub.png';
import HTML5 from '../assets/svg/HTML.png';
import JavaScript from '../assets/svg/JavaScript.png';
import MongoDB from '../assets/svg/MongoDB.png';
import NodeJS from '../assets/svg/NodeJS.png';
import npm from '../assets/svg/npm.png';
import ReactLogo from '../assets/svg/React.png';
import SASS from '../assets/svg/SASS.png';
import VSCode from '../assets/svg/VSCode.png';

import Tool from './Tool';

const Tools = (props) => {
  return (
    <div className="tools">
      <Tool tool="HTML5" logo={HTML5} />
      <Tool tool="CSS3" logo={CSS} />
      <Tool tool="JavaScript" logo={JavaScript} />
      <Tool tool="Sass" logo={SASS} />
      <Tool tool="MongoDB" logo={MongoDB} />
      <Tool tool="Express" logo={Express} />
      <Tool tool="React" logo={ReactLogo} />
      <Tool tool="NodeJS" logo={NodeJS} />
      <Tool tool="Git" logo={Git} />
      <Tool tool="GitHub" logo={GitHub} />
      <Tool tool="npm" logo={npm} />
      <Tool tool="VSCode" logo={VSCode} />
    </div>
  );
};

export default Tools;
